import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { UserCard, Modal } from '../../components';
import EnquiryForm from './EnquiryForm/EnquiryForm';

import { isTeacherRole, isSchoolAdminRole, isParentRole } from '../../util/types';


import css from './ListingPage.module.css';

const SectionAuthorMaybe = props => {
  const {
    title,
    listing,
    authorDisplayName,
    onContactUser,
    isEnquiryModalOpen,
    onCloseEnquiryModal,
    sendEnquiryError,
    sendEnquiryInProgress,
    onSubmitEnquiry,
    currentUser,
    onManageDisableScrolling,
    transition,
    isJob
  } = props;

  if (!listing.author) {
    return null;
  }

  const isTeacher = isTeacherRole(listing.author);
  const isSchoolAdmin = isSchoolAdminRole(listing.author);
  const isParent = isParentRole(listing.author);

  return (
    <div id="author" className={css.sectionAuthor}>
      <h2 className={css.aboutProviderTitle}>
        {isTeacher && <FormattedMessage id="ListingPage.aboutTeacherTitle"/>}
        {isSchoolAdmin && <FormattedMessage id="ListingPage.aboutAdminTitle"/>}
        {isParent && <FormattedMessage id="ListingPage.aboutParentTitle"/>}
      </h2>
      <UserCard user={listing.author} currentUser={currentUser} onContactUser={onContactUser} listing={listing} />
      <Modal
        id="ListingPage.enquiry"
        contentClassName={css.enquiryModalContent}
        isOpen={isEnquiryModalOpen}
        onClose={onCloseEnquiryModal}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <EnquiryForm
          className={css.enquiryForm}
          submitButtonWrapperClassName={css.enquirySubmitButtonWrapper}
          listingTitle={title}
          authorDisplayName={authorDisplayName}
          sendEnquiryError={sendEnquiryError}
          onSubmit={onSubmitEnquiry}
          inProgress={sendEnquiryInProgress}
          transition={transition}
          isJob={isJob}
        />
      </Modal>
    </div>
  );
};

export default SectionAuthorMaybe;
